<template>
  <b-card>
    <template #header>
      <h4 class="mb-0">{{ isEdit ? 'Editar Evento' : 'Novo Evento' }}</h4>
    </template>

    <b-tabs content-class="mt-2" pills>
      <!-- Aba Geral -->
      <b-tab title="Geral" active>
        <EventoGeral :form="form" :is-edit="isEdit" @save="save" @cancel="cancel" />
      </b-tab>

      <!-- Aba Financeiro (Só aparece se o evento tiver cobrança ou se estiver editando para ativar) -->
      <b-tab title="Financeiro">
        <EventoFinanceiro :form="form" :is-edit="isEdit" />
      </b-tab>

      <!-- Aba Logística (Frota e Assentos) -->
      <b-tab title="Logística" v-if="isEdit">
        <EventoLogistica :evento-id="form.id" />
      </b-tab>

      <!-- Aba Hospedagem (Alojamentos) -->
      <b-tab title="Hospedagem" v-if="isEdit">
        <EventoHospedagem :evento-id="form.id" />
      </b-tab>
      
      <!-- Aba Participantes (Inscrições) -->
      <b-tab title="Participantes" v-if="isEdit">
        <EventoParticipantes :evento-id="form.id" />
      </b-tab>

      <!-- Aba Analytics (Dashboard) -->
      <b-tab title="Dashboard" v-if="isEdit">
        <EventoAnalytics :evento-id="form.id" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import EventoGeral from './tabs/EventoGeral.vue'
import EventoFinanceiro from './tabs/EventoFinanceiro.vue'
import EventoLogistica from './tabs/EventoLogistica.vue'
import EventoHospedagem from './tabs/EventoHospedagem.vue'
import EventoParticipantes from './tabs/EventoParticipantes.vue'
import EventoAnalytics from './tabs/EventoAnalytics.vue'
import { mapState } from 'vuex'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    EventoGeral,
    EventoFinanceiro,
    EventoLogistica,
    EventoHospedagem,
    EventoParticipantes,
    EventoAnalytics
  },
  data() {
    return {
      form: {
        id: null,
        nome: '',
        descricao: '',
        tipoEvento: { id: null },
        local: '',
        dataInicial: null,
        dataFinal: null,
        hora: null,
        horaFinal: null,
        qtoVaga: 0,
        publicoAlvo: '',
        status: 'PLANEJADO',
        ativo: true,
        temCobranca: false,
        valor: 0,
        tipoPagamentoRecebimento: { id: null },
        conta: { id: null }
      }
    }
  },
  computed: {
    ...mapState('eventSettingsModule', ['event']),
    isEdit() {
      return !!this.$route.params.id
    }
  },
  async mounted() {
    if (this.isEdit) {
      // Se for edição, carregar os dados pelo ID
      // Idealmente o store já cuidou disso no prepareToEdit ou fazemos fetch aqui
      this.form = JSON.parse(JSON.stringify(this.event))
    } else {
      this.$store.dispatch('eventSettingsModule/resetEvent')
      this.form = JSON.parse(JSON.stringify(this.event))
    }
  },
  methods: {
    async save() {
      const action = this.isEdit ? 'eventSettingsModule/editEvent' : 'eventSettingsModule/insertNewEvent'
      const response = await this.$store.dispatch(action, this.form)
      
      if (response && !response.error) {
        this.$toast({
          component: 'ToastificationContent',
          props: {
            title: 'Sucesso',
            icon: 'CheckIcon',
            variant: 'success',
            text: 'Evento salvo com sucesso!'
          }
        })
        if (!this.isEdit) this.$router.push({ name: 'event' })
      }
    },
    cancel() {
      this.$router.push({ name: 'event' })
    }
  }
}
</script>
